'use client';
import React from 'react';
import { GraduationCap, HelpCircle, Bell } from 'lucide-react';

export default function Topbar() {
  return (
    <header className="h-[52px] bg-white border-b border-border flex items-center justify-between px-4 flex-shrink-0">
      <div className="flex items-center gap-2">
        <GraduationCap size={16} className="text-primary" />
        <span className="text-sm text-muted-foreground font-medium">
          UK Domestic Wiring Simulator
        </span>
        <span className="ml-2 px-2 py-0.5 bg-primary/10 text-primary text-xs font-semibold rounded-full">
          BS 7671
        </span>
      </div>
      <div className="flex items-center gap-2">
        <button className="p-1.5 rounded-lg hover:bg-muted text-muted-foreground hover:text-foreground transition-colors duration-150" title="Help">
          <HelpCircle size={16} />
        </button>
        <button className="p-1.5 rounded-lg hover:bg-muted text-muted-foreground hover:text-foreground transition-colors duration-150" title="Notifications">
          <Bell size={16} />
        </button>
        <div className="flex items-center gap-2 ml-2 pl-2 border-l border-border">
          <div className="w-7 h-7 rounded-full bg-primary/20 flex items-center justify-center">
            <span className="text-xs font-semibold text-primary">S</span>
          </div>
          <span className="text-sm font-medium text-foreground hidden sm:block">Student</span>
        </div>
      </div>
    </header>
  );
}